module.exports = __webpack_public_path__ + "static/media/thumb_methin_503x503.0836c4f9.jpg";